/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Printing_DocumentsInputs */

const en_orders_printing_documents = /** @type {(inputs: Orders_Printing_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Printing...`)
};

const es_orders_printing_documents = /** @type {(inputs: Orders_Printing_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imprimiendo...`)
};

/**
* | output |
* | --- |
* | "Printing..." |
*
* @param {Orders_Printing_DocumentsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_printing_documents = /** @type {((inputs?: Orders_Printing_DocumentsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Printing_DocumentsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_printing_documents(inputs)
	return es_orders_printing_documents(inputs)
});